import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';

export interface IFromPackageProps {
  checked: boolean;
  onChange(checked: boolean): void;
}

export const FromPackage = ({ checked, onChange }: IFromPackageProps) => {
  const handleChange = React.useCallback((_, checked) => onChange(checked), [onChange]);

  return <Checkbox checked={checked} onChange={handleChange} label="Разместить из пакета" />;
};
